<template>
  <v-app>
    <v-content>
      <v-container>
        <v-card-title>
          <v-row>
            <v-col>Rank Ladder</v-col>
            <v-col cols="1">
              <!-- @change="changePage" -->
              <v-select
                :items="pages"
                v-model="page.page"
                open-on-clear
                label="Pages"
                :menu-props="{ offsetY: true }"
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                @input="searchF"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          class="elevation-1"
          dense
          :headers="headers"
          :items="users"
          :items-per-page="50"
          :options.sync="options"
          :page.sync="page.page"
          :search="search"
          no-data-text="loading"
          :footer-props="{
              'items-per-page-options': [50]
          }"
          @pagination="getNewPage"
          @update:sort-by="sortBy"
          @update:sort-desc="sortDesc"
          :server-items-length.sync="totalUsers"
          :loading="loading"
        >
          <template v-slot:item.number="{ item }">
            <span>{{ rankNumber(item) }}</span>
          </template>
          <template v-slot:item.level_id="{ item }">
            <span>
              <v-img max-height="26" max-width="26" :src="getImage(item)"></v-img>
            </span>
          </template>
          <!-- <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
            <v-row class="d-flex">
              <v-col>
                <span>{{ pageStart }}-{{ pageStop }} of {{ itemsLength }}</span>
              </v-col>
            </v-row>
          </template>-->
        </v-data-table>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://classic-leaderboard.slingoarcade.com";
export default {
  name: "LApp",
  components: {},
  BASE_URL: BASE_URL,
  data: () => ({
    message: "main components",
    totalUsers: 2505353,
    page: {
      itemsPerPage: 50,
      page: 1
    },
    rankN: 1,
    sortByV: "total_points",
    sort_desc: true,
    search: "",
    pagination: {},
    users: [],
    loading: true,
    options: {},
    headers: [
      { text: "#", align: "start", value: "number" },
      { text: "Rank", value: "level_id" },
      { text: "Day Points", value: "day_points" },
      { text: "Week Points", value: "week_points" },
      { text: "Month Points", value: "month_points" },
      { text: "Total Points", value: "total_points" },
      { text: "Username", value: "username" }
    ]
  }),
  // watch: {
  //   options: {
  //     handler() {
  //       this.getData(this.page).then(data => {
  //         this.users = data.data;
  //       });
  //     },
  //     deep: true
  //   }
  // },
  computed: {
    pages: function() {
      let c = [];
      let cc = this.totalUsers / 50 + 1;
      for (let i = 0; i < cc; i++) {
        c.push(i + 1);
      }
      return c;
    }

    // rankNumber: function() {
    //   let n = this.page.page + 1 + this.rankN;
    //   this.rankN++;
    //   return n;
    // }
  },
  methods: {
    zeroPad: function(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    getImage: function(e) {
      let path = "0";
      if (e.level_id < 10) {
        path = this.zeroPad(e.level_id, 2);
      } else {
        path = e.level_id;
      }
      let imagePath = `/img/rank_imgs/rank_lrg_${path}.jpg`;
      return imagePath;
    },
    changePage: function(p) {
      this.page.page = p;
      this.getData().then(e => {
        this.users = e.data;
        this.totalUsers = e.headers["content-range"].split("/")[1];
      });
    },
    rankNumber: function(item) {
      let index = this.users
        .map(function(x) {
          return x.uid;
        })
        .indexOf(item.uid);
      let n = index + 1 + (this.page.page - 1) * this.page.itemsPerPage;
      return n;
    },
    customValue: function() {
      return 1;
    },
    searchF: function() {
      this.getData().then(e => {
        this.users = e.data;
        this.totalUsers = e.headers["content-range"].split("/")[1];
      });
    },

    sortDesc(e) {
      console.log("sort desc ", e);
      this.sort_desc = e[0];
      this.getData().then(e => {
        this.users = e.data;
        this.totalUsers = e.headers["content-range"].split("/")[1];
      });
      this.loading = false;
    },
    sortBy(e) {
      this.loading = true;
      if (e === undefined) {
        this.sortByV = "total_points"; // Default
      } else if (Array.isArray(e) && e[0] !== undefined) {
        this.sortByV = e[0];
      } else if (!Array.isArray(e)) {
        this.sortByV = e;
      }
      this.getData().then(e => {
        this.users = e.data;
        this.totalUsers = e.headers["content-range"].split("/")[1];
      });
      this.loading = false;
    },
    getNewPage(page) {
      this.page = page;
      this.getData().then(e => {
        // console.log("e.data", e.data);
        this.users = e.data;
        this.totalUsers = e.headers["content-range"].split("/")[1];
      });
    },
    getData() {
      this.loading = true;
      let page = this.page;
      let sortBy = this.sortByV;
      // console.log("GET DATA SORT BY ", sortBy);
      this.sort_desc ? (sortBy = `${sortBy}.desc`) : (sortBy = `${sortBy}`);
      // console.log("AFTER SORT DESC ", sortBy);
      let offset = (page.page - 1) * page.itemsPerPage;
      let URL = "";
      if (this.search !== "") {
        let offset = 0;
        URL = `${BASE_URL}/users?limit=${page.itemsPerPage}&offset=${offset}&order=${sortBy}&username=like.${this.search}*`;
      } else {
        URL = `${BASE_URL}/users?limit=${page.itemsPerPage}&offset=${offset}&order=${sortBy}`;
      }
      let r = axios.get(URL, { headers: { Prefer: "count=exact" } });
      this.loading = false;
      return r;
    },
    getPage: function() {
      // console.log("this is pagination", event);
    }
  },
  mounted() {
    this.getData(this.page)
      .then(e => {
        this.users = e.data;
        this.totalUsers = e.headers["content-range"].split("/")[1];
      })
      .catch(c => {
        console.log("Error ", c.data);
      });
  }
};
</script>
